module.exports = __webpack_public_path__ + "static/media/Banner-promo-Tigres-B.e44aed85.png";